import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';

import { Campaign } from './../../models/newsletter/campaigns.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Dropdown } from './../../models/editors/dropdown.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

export const SUCCESS_MESSAGE = 'Odběratel byl úspěšně uložen!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Component({
  selector: 'swb-campaign-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class CampaignDetailComponent extends FormDetailBase<Campaign> implements OnInit {
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Titulek (název)',
        validators: [Validators.required]
      }),
      new Textarea({
        key: 'content',
        label: 'Obsah',
        validators: [Validators.required],
        wysiwyg: 'campaign-detail'
      }),
      new Dropdown({
        key: 'language',
        label: 'Jazyk',
        options: [{ value: 'cs', text: 'cs' }],
        value: 'cs',
        placeholder: 'Vyberte jazyk'
      })
    ];
  }
  public url = 'campaigns';
  protected _redirect = './newsletter';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
